import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SectionTemplateComponent } from '@templates/section-template/section-template.component';
import { DatePipe } from '@angular/common';
import { IHome_ImportantDatesResponse } from '@shared/constants/models.const';
import { TranslateModule } from '@ngx-translate/core';
import { HelperService } from '../../../../services/helper.service';
import { E_DATE_FORMAT } from '@shared/constants/enums.const';
import { OnlyDate } from '@shared/pipes/only-date';

@Component({
  selector: 'app-important-dates-section',
  imports: [
    SectionTemplateComponent,
    DatePipe,
    TranslateModule,
    OnlyDate,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './important-dates-section.component.html',
  styleUrl: './important-dates-section.component.scss',
})
export class ImportantDatesSectionComponent {
  data = input<IHome_ImportantDatesResponse[]>();
  protected readonly E_DATE_FORMAT = E_DATE_FORMAT;

  constructor(
    public HELPER: HelperService,
  ) {
  }


  dateIsEqual(startDate: string, endDate: string) {
    const newStartDate = startDate?.toLowerCase()?.split('t')[0];
    const newEndDate = endDate?.toLowerCase()?.split('t')[0];

    return this.HELPER.getFormatedDate(newStartDate) === this.HELPER.getFormatedDate(newEndDate);
  }
}
